export class BulkPrice {
  id?: number;
  bulkNumber?: number;
  unitPrice?: number;
  capShape?: number;
  descending?: number;
  reflecting?: number;

  constructor(init?: Partial<BulkPrice>) {
    Object.assign(this, init);
  }
}
